import ClientApplication from '../../../api/application/interfaces/ClientApplication'
import { convertAppValuesBase } from '../sharedConvertAppValues'
import { tradeInFieldNames } from './automobileApplicationFields'

const convertAppValues = (app: ClientApplication) =>
    convertAppValuesBase(app, (data) => ({
        ...data,
        [tradeInFieldNames.intent]: app.trade_in_intent,
    }))

export default convertAppValues
